import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class User extends ConsoleApi {
    /**
     *
     */
    protected readonly resource = '/users';

    /**
     * @param accountId
     * @param userName
     */
    public show(accountId: string, userName: string): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + '/' + userName, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param userName
     * @param name
     * @param nameKana
     * @param contactPhoneNumber
     */
    public update(accountId: string, userName: string, name: string, nameKana: string, contactPhoneNumber: string): Promise<AxiosResponse> {
        return this.axios.put(this.requestUri + this.getAccountResource(accountId) + '/' + userName, {
            name: name,
            "name_kana": nameKana,
            "contact_phone_number": contactPhoneNumber,
        },{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}